var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_801_3041",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 0.5H0.299805V14.5H14.2998V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_801_3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0726 5.69083L9.25999 1.53499C8.83873 1.17118 8.1748 1.46652 8.1748 2.03166V4.22061C3.7826 4.27089 0.299805 5.15117 0.299805 9.3136C0.299805 10.9936 1.38209 12.658 2.57844 13.5281C2.95176 13.7997 3.48382 13.4589 3.34617 13.0187C2.10629 9.0535 3.93425 8.00082 8.1748 7.93982V10.3437C8.1748 10.9098 8.83925 11.2038 9.25999 10.8404L14.0726 6.68417C14.3753 6.42271 14.3757 5.95264 14.0726 5.69083Z",
    fill: "#99989F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d4989a40a752f64014279598dc545d06.svg";
export { ForwardRef as ReactComponent };